export default {
  app: 'APP_RECOVER',
  api: 'https://www.researchfollowapp.com/portal'
};
